import React from "react";
import { motion } from "framer-motion";
import { projects } from "../../data/constants";
import ProjectCard from "../Cards/ProjectCards";
import OtherProjects from "./OtherProjects";
import {
  fadeUp,
  revealLine,
  staggerContainer,
  viewport,
} from "../../utils/motion";
import {
  SectionWrap,
  SectionInner,
  SectionHead,
  Eyebrow,
  SectionTitle,
  SectionDesc,
  MaskLine,
  RuleLabel,
} from "../common/Section";
import { FeaturedStack, RomanDivider } from "./ProjectsStyle";

// Projects / "Quest Log". Featured quests stack one per row separated by
// roman-numeral rules; everything else drops into the Side Quests grid.
// The objective has no category filter, so the old filter pills are gone.

const ROMAN = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"];

// Featured tier is explicitly ordered via `featuredOrder` in constants.js
// rather than by array position, so reordering is a one-number change.
const featured = projects
  .filter((p) => p.featured)
  .sort((a, b) => (a.featuredOrder ?? 99) - (b.featuredOrder ?? 99));

// Same treatment for the Other Projects grid — order lives in the data.
const other = projects
  .filter((p) => !p.featured)
  .sort((a, b) => (a.otherOrder ?? 99) - (b.otherOrder ?? 99));

const Projects = () => (
  <SectionWrap id="projects" tone="projects">
    <SectionInner>
      <SectionHead
        variants={staggerContainer(0.08)}
        initial="hidden"
        whileInView="show"
        viewport={viewport}
      >
        <Eyebrow tone="projects" variants={fadeUp}>
          Selected work
        </Eyebrow>
        <MaskLine>
          <SectionTitle tone="projects" variants={revealLine}>
            Projects
          </SectionTitle>
        </MaskLine>
        <SectionDesc tone="projects" variants={fadeUp}>
          What I built, how I tested it, and where it falls short.
        </SectionDesc>
      </SectionHead>

      <FeaturedStack
        variants={staggerContainer(0.08)}
        initial="hidden"
        whileInView="show"
        viewport={viewport}
      >
        {featured.map((project, i) => (
          <motion.div key={project.id} variants={fadeUp}>
            <RomanDivider>{ROMAN[i] || i + 1}</RomanDivider>
            <ProjectCard project={project} />
          </motion.div>
        ))}
      </FeaturedStack>

      <RuleLabel tone="projects">Other Projects</RuleLabel>
      <OtherProjects projects={other} />
    </SectionInner>
  </SectionWrap>
);

export default Projects;
